var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKucoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.4025 7L8.55993 11.1574L11.1646 8.55277C11.6154 8.15206 12.3667 8.15206 12.8175 8.60286C13.2683 9.05367 13.2683 9.75492 12.8676 10.2558L9.36136 13.6619C8.91055 14.1127 8.15921 14.1127 7.70841 13.6619L2.69946 8.65295V11.6583C2.69946 12.3095 2.14848 12.8605 1.49731 12.8605C0.84615 12.8605 0.295166 12.3095 0.295166 11.6583V2.39177C0.295166 1.74061 0.84615 1.18962 1.49731 1.18962C2.14848 1.18962 2.69946 1.74061 2.69946 2.39177V5.34705L7.70841 0.338104C8.15921 -0.112701 8.91055 -0.112701 9.36136 0.338104L12.8175 3.79427C13.2182 4.24508 13.2182 4.99642 12.7674 5.44723C12.3166 5.89803 11.6154 5.89803 11.1145 5.49732L8.50984 2.89266L4.4025 7ZM8.55993 5.84794C8.05903 5.84794 7.65832 6.14848 7.45796 6.59929C7.2576 7.05009 7.35778 7.55098 7.70841 7.90161C8.05903 8.25224 8.55993 8.35241 9.01073 8.15206C9.46154 7.9517 9.76207 7.55098 9.76207 7.05009C9.76207 6.74955 9.66189 6.44902 9.41145 6.19857C9.161 5.94812 8.86046 5.84794 8.55993 5.84794Z",
    fill: "#23AF91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKucoin);
export default __webpack_public_path__ + "static/media/kucoin.6a3bec17690910ff60b0fb84c11797d2.svg";
export { ForwardRef as ReactComponent };